import { Box, Paper } from '@mui/material';
import BreadCrumbs from 'components/Breadcrumbs/Breadcrumbs';
import DrawerHeader from 'components/DrawerHeader';
import DisplayEntity from 'components/PageBuilder/DisplayEntity';
import TableMonitoring from 'components/TableMonitoring';
import NoDataTableBody from 'components/TableMonitoring/Body/NoDataTableBody';
import TableRowStatic from 'components/TableMonitoring/Body/TableRowStatic';
import TableHeaderStatic from 'components/TableMonitoring/Header/Static/TableHeaderStatic';
import { CommonTexts, alertsTexts } from 'locale/es';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { AlertsTableRows } from './AlertsTableRows';
import { useDispatch, useSelector } from 'react-redux';
import usePagination from 'hooks/usePagination';
import useSortedData from 'hooks/useSortedData';
import { useEffect, useState } from 'react';
import { fetchMoreAlertsAction, initializeAlerts } from 'redux/reducers/alertsReducer';
import DeleteMenuOption from 'components/TableMonitoring/Body/RowMenuListActions/DeleteMenuOption';
import { Outlet } from 'react-router-dom';
import Loader from 'components/Loader/Loader';

const tableHeaders = [
  {
    id: "message",
    label: "Missatge",
    isSortable: false
  },
  {
    id: "patient",
    label: "Pacient",
    isSortable: false
  },
  {
    id: "creationDate",
    label: "Data",
    isSortable: true
  },
  {
    id: "viewed",
    label: "Vist",
    isSortable: true
  }
]

export function Alerts() {
  const selectedCenter = useSelector(({ center }) => center)?.data
  const { data, totalCount, loading, error } = useSelector(({ alerts }) => alerts)

  const dispatch = useDispatch()

  const {
    sortedData,
    sortColumn,
    sortDirection,
    handleRequestSort
  } = useSortedData(data, "viewed", "asc", false);

  const {
    visibleRows,
    paginationComponent
  } = usePagination(0, 10, sortedData, totalCount, handleInitializeAlerts, handleFetchMoreAlerts);


  // useEffect(() => {
  //   if (selectedCenter.id && data.length === 0) {
  //     handleInitializeAlerts(0, 10)
  //   }
  // }, [selectedCenter.id])


  function handleInitializeAlerts(page, rowsPerPage) {
    dispatch(initializeAlerts(selectedCenter.id, page, rowsPerPage))
  }

  function handleFetchMoreAlerts(page, rowsPerPage) {
    return dispatch(fetchMoreAlertsAction(selectedCenter.id, page, rowsPerPage))
  }

  if (loading) {
    return (
      <Loader message={alertsTexts.LOADING} pt={32} />
    )
  }

  return (
    <>
      <Box component="main" sx={{ flex: 1, p: 3, mb: 20 }}>
        <DrawerHeader />
        <BreadCrumbs
          name={CommonTexts.ALERTS}
          icon={<ReportProblemIcon sx={{ mr: 0.5 }} fontSize="inherit" />}
        />
        <Paper sx={{ width: '100%', mb: 2 }}>
          <DisplayEntity entityId={selectedCenter.id}>
            <TableMonitoring
              tableHeader={
                <TableHeaderStatic
                  tableHeaders={tableHeaders}
                  entity={selectedCenter}
                  sortDirection={sortDirection}
                  sortColumn={sortColumn}
                  onSort={handleRequestSort}
                />}
            >
              {visibleRows?.length > 0 && visibleRows?.map((alert) => (
                <TableRowStatic
                  key={alert.id}
                  entity={alert}
                  loaded={!loading}
                  actions={
                    <DeleteMenuOption entityId={alert.id} />
                  }
                >
                  <AlertsTableRows alert={alert} />
                </TableRowStatic>
              ))}
            </TableMonitoring>
            {visibleRows?.length === 0 &&
              <NoDataTableBody
                entity={selectedCenter.id}
                noDataMessage={alertsTexts.NO_DATA}
              />
            }
            {paginationComponent}
          </DisplayEntity>
        </Paper>
      </Box>
      <Outlet />
    </>
  )
}